import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./PasswordReset.css";

const PasswordResetPage = () => {
  const [email, setEmail] = useState("");  
  const navigate = useNavigate(); 
  
  const temp_id = "673f72c124daa756e66378d9";
  
  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const RequestPasswordResetOtp = async () => {
    if (!email.trim()) {
      alert("Enter the email address for your admin account.");
      return;
    }

    try {
      // The OTP is sent by /password-reset/otp. This called /password-reset,
      // which exists only as a POST (that endpoint SETS the new password), so
      // the GET returned 404 and no email was ever sent — the reset could
      // never be started.
      const response = await fetch(
        `https://admin.riymay.com/api/v1/admin/password-reset/otp?email=${encodeURIComponent(email.trim())}`
      );

      const data = await response.json().catch(() => ({}));
      const message = data.Message || data.message || "";

      // The server answers 200 even when the address is not registered, so the
      // body has to be read. Without this the page reported success and sent
      // the admin on to type a code that was never going to arrive.
      if (!response.ok || /not found|requerid|required/i.test(message)) {
        alert(message || "Could not send the code. Please try again.");
        return;
      }

      alert("Code sent. Check your email.");
      navigate('/password-change', { state: { email: email.trim() } });
    } catch (error) {
      console.error("Error during OTP request:", error);
      alert("Could not reach the server. Please try again.");
    }
  };

  return (
    <div className="password-reset-container">
      <div className="password-reset-card">
        <h2>Reset Your Password</h2>
        <p>Please enter your email to receive an OTP for resetting your password.</p>
        <div className="form-group">
          <label htmlFor="user-email">Email Address</label>
          <input
            id="user-email"
            type="email"
            className="email-input"
            value={email}
            onChange={handleEmailChange}
            placeholder="Enter your email"
            required
          />
        </div>
        <button className="submit-button" onClick={RequestPasswordResetOtp}>
          Submit
        </button>
      </div>
    </div>
  );
};

export default PasswordResetPage;
